import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import RegisterBusiness from '../pages/auth/RegisterBusiness';
import DashboardCalendarView from '../pages/master/Dashboard';
import BookingDetails from '../pages/master/BookingDetails';
import ServiceEditor from '../pages/master/ServiceEditor';
import Schedule from '../pages/master/Schedule';
import RouteGuard from '../components/common/RouteGuard';
import CreateBooking from '../pages/master/CreateBooking';
import Accounting from '../pages/master/Accounting';
import Promos from '../pages/master/Promos';
import Cabinet from '../pages/user/Cabinet';
import Team from '../pages/workspace/Team';
import Clients from '../pages/workspace/Clients';
import ThemeEditor from '../pages/workspace/Theme';
import SalonProfileEditor from '../pages/workspace/Profile';
import Billing from '../pages/workspace/Billing';
import BookingTermsEditor from '../pages/workspace/BookingTermsEditor';
import AdminWorkspaces from '../pages/admin/Workspaces';
import AdminBilling from '../pages/admin/Billing';
import BookByLink from '../pages/booking/BookByLink';
import ConfirmByLink from '../pages/booking/ConfirmByLink';
import BookSuccess from '../pages/booking/BookSuccess';
import PaymentPage from '../pages/PaymentPage';
import PaymentResult from '../pages/PaymentResult';
import Home from '../pages/Home';
import LegalPage from '../pages/legal/LegalPage';
import { Navigate } from 'react-router-dom';
import { salonSlugFromHost } from '../utils/host';

export default function AppRouter() {
  // На піддомені салону (<slug>.<домен>) корінь = публічна сторінка цього салону;
  // слаг береться з хоста, тож без префікса /w/:slug. Лише публічний флоу.
  if (salonSlugFromHost()) {
    return (
      <Routes>
        <Route path="/" element={<BookByLink />} />
        <Route path="/book" element={<BookByLink />} />
        <Route path="/book/:hash" element={<BookByLink />} />
        <Route path="/confirm/:hash" element={<ConfirmByLink />} />
        <Route path="/book-success" element={<BookSuccess />} />
        <Route path="/pay/:hash" element={<PaymentPage />} />
        <Route path="/payment/:status" element={<PaymentResult />} />
        <Route path="/terms" element={<LegalPage doc="terms" />} />
        <Route path="/privacy" element={<LegalPage doc="privacy" />} />
        <Route path="/cookies" element={<LegalPage doc="cookies" />} />
        <Route path="/dpa" element={<LegalPage doc="dpa" />} />
        <Route path="/refund" element={<LegalPage doc="refund" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Маркетплейс для клієнтів приховано (платформа поки лише для салонів) */}
      <Route path="/discover" element={<Navigate to="/" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-business" element={<RegisterBusiness />} />
      <Route path="/master/dashboard" element={<RouteGuard role="master"><DashboardCalendarView /></RouteGuard>} />
      <Route path="/master/booking/:id" element={<RouteGuard role="master"><BookingDetails /></RouteGuard>} />
      <Route path="/master/services" element={<RouteGuard role="master"><ServiceEditor /></RouteGuard>} />
      <Route path="/master/schedule" element={<RouteGuard role="master"><Schedule /></RouteGuard>} />
      <Route path="/master/create" element={<RouteGuard role="master"><CreateBooking /></RouteGuard>} />
      <Route path="/master/accounting" element={<RouteGuard role="master"><Accounting /></RouteGuard>} />
      <Route path="/master/promos" element={<RouteGuard role="master"><Promos /></RouteGuard>} />
      <Route path="/workspace/team" element={<RouteGuard role="master"><Team /></RouteGuard>} />
      <Route path="/workspace/clients" element={<RouteGuard role="master"><Clients /></RouteGuard>} />
      <Route path="/workspace/profile" element={<RouteGuard role="master"><SalonProfileEditor /></RouteGuard>} />
      <Route path="/workspace/billing" element={<RouteGuard role="master"><Billing /></RouteGuard>} />
      <Route path="/workspace/theme" element={<RouteGuard role="master"><ThemeEditor /></RouteGuard>} />
      <Route path="/workspace/terms" element={<RouteGuard role="master"><BookingTermsEditor /></RouteGuard>} />
      <Route path="/admin/workspaces" element={<RouteGuard role="superadmin"><AdminWorkspaces /></RouteGuard>} />
      <Route path="/admin/billing" element={<RouteGuard role="superadmin"><AdminBilling /></RouteGuard>} />
      <Route path="/user/cabinet" element={<RouteGuard role="user"><Cabinet /></RouteGuard>} />
      <Route path="/book/:hash" element={<BookByLink />} />
      {/* «Нічийної» сторінки запису немає — бронювання лише через сторінку салону
          (/w/:slug, піддомен або персональний лінк майстра /book/:hash) */}
      <Route path="/book" element={<Navigate to="/" replace />} />
      <Route path="/w/:slug" element={<BookByLink />} />
      <Route path="/w/:slug/book" element={<BookByLink />} />
      <Route path="/confirm/:hash" element={<ConfirmByLink />} />
      <Route path="/book-success" element={<BookSuccess />} />
      <Route path="/pay/:hash" element={<PaymentPage />} />
      <Route path="/payment/:status" element={<PaymentResult />} />
      <Route path="/terms" element={<LegalPage doc="terms" />} />
      <Route path="/privacy" element={<LegalPage doc="privacy" />} />
      <Route path="/cookies" element={<LegalPage doc="cookies" />} />
      <Route path="/dpa" element={<LegalPage doc="dpa" />} />
      <Route path="/refund" element={<LegalPage doc="refund" />} />
    </Routes>
  );
}
